import { makeStyles } from '@material-ui/core/styles';
import { fill } from '../../../utils/contrastSvgAttributes';

export const useStyles = makeStyles(() => ({
  button: {
    ml: 2,
    color: 'black',
    '&:hover': {
      color: '#3C419A',
      background: 'White',
    },
  },
  sx: {
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      fontSize: '14px',
      '& path': {
        fill: fill,
      },
      '&:hover': {
        backgroundColor: 'rgba(202, 202, 252, 0.2)',
        color: '#3C419A',
        '& .MuiListItemIcon-root': {
          color: '#3C419A',
        },
        '& path': {
          fill: '#3C419A',
        },
      },
    },
    '& .MuiListItemIcon-root': {
      minWidth: 40,
    },
  },
  box: {
    display: 'inline-flex',
    alignItems: 'center',
    textAlign: 'center',
  },
}));
